import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import useAppContext from "../../../utils/Reducers";
import SelectBox from "../../../components/SelectBox";

const ArriveCallPop = ({ schPlantCd, onArriveCall }) => {
  //차량 검색 URL
  //공통코드 검색 URL
  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";
  const [scrapAreaCd, setScrapAreaCd] = useState("");
  const [show, setShow] = useState(true);

  const {
    store: { userInfo },
  } = useAppContext();

  const handleClose = (returnData) => {
    setShow(false);
  };

  const initItem = {
    scrapAreaCd: "",
    scrapAreaNm: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  //console.log(schPlantCd);

  const handleOk = (returnData) => {
    if (fieldValues.scrapAreaCd === "") {
      alert("도착지역을 선택하지 않았습니다. ");
    } else {
      onArriveCall(fieldValues);
      setShow(false);
    }
  };

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    var scrapAreaNm = event.target.options[event.target.selectedIndex].text;
    setFieldValues({
      ...fieldValues,
      [name]: value,
      ["scrapAreaNm"]: scrapAreaNm,
    });
  });

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title> 도착 지역 선택</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchdata">
            <ul>
              <li style={{ width: "300px" }}>
                <div className="divide50">
                  <font color="grey">⦁</font> 도착지역
                </div>

                <SelectBox
                  mastCd="SCRAP_AREA_CD"
                  id="scrapAreaCd"
                  name="scrapAreaCd"
                  topSelected="선택"
                  attr3={schPlantCd}
                  onChange={handleChangeField}
                  value={fieldValues.scrapAreaCd}
                  className="ip2"
                />
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose(false)}>
            취소
          </Button>

          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalArriveCallPop = createModal(ArriveCallPop);

export default ArriveCallPop;
